// @ts-nocheck - fix me
import useLocalization from '@/assets/localizations';
import { imageSource } from '@/libs/imageSource';
import { InternationalPhoneInput } from '@/screens/components/InternationalPhoneInput';
import AppConfig from '@config';
import { useNavigation } from '@react-navigation/native';
import { useAppContext, useAppStore } from '@store';
import { VERIFICATIONFingerprint } from '@svgs';
import format from 'date-fns-tz/format';
import differenceInYears from 'date-fns/differenceInYears';
import React, { useRef, useState } from 'react';
import {
  Country as PhoneCountry,
  isValidPhoneNumber,
} from 'react-phone-number-input/max';
import countryNames from 'react-phone-number-input/locale/en.json';
import { View } from 'react-native';
import CountryPicker, { Country } from 'react-native-country-picker-modal';
import countryPickerCloseImage from 'react-native-country-picker-modal/lib/assets/images/close.ios.png';
import { Button, HelperText, TextInput } from 'react-native-paper';
import { DatePickerModal, MultiConfirm } from 'react-native-paper-dates';
import Svg from 'react-native-svg';
import SimpleReactValidator from 'simple-react-validator';
import { useVerification } from '../../../store/verification/hooks';
import { ContentView, HeaderView } from '../../login/Common';
import { LoginStyles } from '../../login/Styles';

// @@ Action view
const ActionView = () => {
  const { locale } = useAppContext();
  const [showErrors, setShowErrors] = React.useState(false);
  const [errors, setErrors] = useState({});
  const { verification, setVerification } = useVerification();
  const [localVerification, setLocalVerification] = useState(verification);
  const [isCountryPickerVisible, setIsCountryPickerVisible] = useState(false);
  const [isEditedCountryOrPhone, setIsEditedCountryOrPhone] = useState(false);
  const { t } = useLocalization();
  const navigation = useNavigation();
  const [chosenDate, setChosenDate] = React.useState<Date | undefined>(
    undefined,
  );
  const [phoneCountry, setPhoneCountry] = useState<PhoneCountry>('US');

  const simpleValidator = useRef(
    new SimpleReactValidator({
      messages: {
        required: t('required'),
      },
      validators: {
        dateValidator: {
          message: 'Your age should be more than 18 to verify',
          rule: (val: string) => {
            const userBirthDate = new Date(val);
            const userAge = differenceInYears(Date.now(), userBirthDate);
            return userAge >= 18;
          },
        },
        validPhoneNumber: {
          message: t('invalid_phone_message'),
          rule: (val: string) =>
            isValidPhoneNumber(`+${val.replace(/^\+/, '')}`),
        },
      },
    }),
  );

  const [openDateModal, setOpenDateModal] = React.useState(false);

  const onPressNext = () => {
    if (simpleValidator.current.allValid()) {
      setVerification({ ...verification, ...localVerification });
      navigation.navigate('Methods');
    } else {
      simpleValidator.current.showMessages();
      setErrors(simpleValidator.current.errorMessages);
      setShowErrors(true);
    }
  };
  const onPressBack = () => {
    navigation.navigate('Disclaimer');
  };

  const phoneNumberUpdate = (value: string, country?: PhoneCountry) => {
    const updateCountry = !isEditedCountryOrPhone && country;
    setLocalVerification(previous => ({
      ...previous,
      // Verification expects country calling code + national number, without '+'.
      phone: value.replace(/^\+/, ''),
      ...(updateCountry && {
        address: { ...previous?.address, country: countryNames[country] },
        countryISO: country,
      }),
    }));
    if (updateCountry) {
      setIsEditedCountryOrPhone(true);
    }
  };

  const localVerificaionSetter = (e: unknown) => {
    const { id, value } = e.target;
    if (
      ['addressLine1', 'town', 'province', 'country', 'postcode'].includes(id)
    ) {
      setLocalVerification({
        ...localVerification,
        address: { ...localVerification.address, [id]: value },
      });
    } else {
      setLocalVerification({ ...localVerification, [id]: value });
    }
  };

  const onSelectCountry = (chosenCountry: Country) => {
    const chosenCCA = chosenCountry?.cca2 as string | null;
    const chosenName = chosenCountry?.name as string | null;
    if (!isEditedCountryOrPhone) {
      setIsEditedCountryOrPhone(true);
      setPhoneCountry(chosenCountry.cca2);
    }
    setLocalVerification({
      ...localVerification,
      address: { ...localVerification.address, country: chosenName },
      countryISO: chosenCCA?.toLowerCase(),
    });
    setIsCountryPickerVisible(false);
  };
  return (
    <View
      style={{
        width: '100%',
        paddingHorizontal: AppConfig.Styles.getAdjustedSize(24),
        paddingBottom: AppConfig.Styles.getAdjustedSize(24),
      }}>
      <View style={[AppConfig.Styles.container]}>
        <DatePickerModal
          locale={locale}
          mode="single"
          visible={openDateModal}
          onDismiss={() => {
            setOpenDateModal(false);
          }}
          date={chosenDate}
          onConfirm={(params: MultiConfirm) => {
            setChosenDate(params.date);
            setLocalVerification({
              ...localVerification,
              dateOfBirth: format(params.date, 'yyyy-MM-dd'),
            });
            setOpenDateModal(false);
          }}
          animationType="slide" // optional, default is 'slide' on ios/android and 'none' on web
        />
        <View style={[AppConfig.Styles.container, { display: 'none' }]}>
          <CountryPicker
            countryCode="CA"
            closeButtonImage={imageSource(countryPickerCloseImage)}
            withAlphaFilter
            withCallingCode
            onSelect={onSelectCountry}
            onClose={() => {
              setIsCountryPickerVisible(false);
            }}
            visible={isCountryPickerVisible}
          />
        </View>

        <TextInput
          nativeID="firstName"
          style={{
            height: AppConfig.Styles.inputHeight,
          }}
          mode="outlined"
          label={t('signup_first_name')}
          placeholder={t('signup_first_name')}
          value={localVerification?.firstName ?? verification?.firstName}
          onChange={localVerificaionSetter}
          error={errors?.firstName && showErrors}
        />
        <HelperText type="error">
          {simpleValidator.current.message(
            'firstName',
            localVerification.firstName,
            'required',
          )}
        </HelperText>
        <TextInput
          nativeID="lastName"
          style={{
            height: AppConfig.Styles.inputHeight,
          }}
          mode="outlined"
          label={t('signup_last_name')}
          placeholder={t('signup_last_name')}
          value={localVerification?.lastName ?? verification?.lastName}
          onChange={localVerificaionSetter}
          error={errors?.lastName && showErrors}
        />
        <HelperText type="error">
          {simpleValidator.current.message(
            'lastName',
            localVerification?.lastName,
            'required',
          )}
        </HelperText>
        <TextInput
          nativeID="addressLine1"
          style={{
            height: AppConfig.Styles.inputHeight,
          }}
          mode="outlined"
          label={t('address_line_1')}
          placeholder={t('street_address')}
          value={
            localVerification?.address?.addressLine1 ??
            verification?.address?.addressLine1
          }
          onChange={localVerificaionSetter}
          error={errors?.addressLine1 && showErrors}
        />
        <HelperText type="error">
          {simpleValidator.current.message(
            'addressLine1',
            localVerification?.address?.addressLine1,
            'required',
          )}
        </HelperText>

        <View
          style={[
            AppConfig.Styles.rowContainer,
            {
              justifyContent: 'space-between',
              marginBottom: `${
                !errors?.province && !errors?.town ? '10px' : ''
              }`,
            },
          ]}>
          <TextInput
            nativeID="town"
            style={{
              height: AppConfig.Styles.inputHeight,
              width: '49%',
            }}
            mode="outlined"
            label={t('city')}
            placeholder={t('city_description')}
            value={
              localVerification?.address?.town ?? verification?.address?.town
            }
            onChange={localVerificaionSetter}
            error={errors?.town && showErrors}
          />
          <TextInput
            nativeID="province"
            style={{
              height: AppConfig.Styles.inputHeight,
              width: '49%',
            }}
            mode="outlined"
            label={t('province')}
            placeholder={t('province_description')}
            value={
              localVerification?.address?.province ??
              verification?.address?.province
            }
            onChange={localVerificaionSetter}
            error={errors?.province && showErrors}
          />
        </View>
        <View
          style={[
            AppConfig.Styles.rowContainer,
            {
              justifyContent: 'flex-start',
              display: `${!errors?.province && !errors?.town ? 'none' : ''}`,
            },
          ]}>
          <View style={[AppConfig.Styles.container]}>
            <HelperText type="error">
              {simpleValidator.current.message(
                'town',
                localVerification?.address?.town,
                'required',
              )}
            </HelperText>
          </View>
          <View style={[AppConfig.Styles.container]}>
            <HelperText type="error">
              {simpleValidator.current.message(
                'province',
                localVerification?.address?.province,
                'required',
              )}
            </HelperText>
          </View>
        </View>

        <View
          style={[
            AppConfig.Styles.rowContainer,
            {
              justifyContent: 'space-between',
              marginBottom: `${
                !errors['postal code'] && !errors?.country ? '10px' : ''
              }`,
            },
          ]}>
          <TextInput
            nativeID="chosenCountry"
            style={{
              height: AppConfig.Styles.inputHeight,
              width: '49%',
            }}
            mode="outlined"
            label={t('country')}
            autoComplete="false"
            auto
            value={
              localVerification?.address?.country ??
              verification?.address?.country
            }
            onFocus={() => {
              setIsCountryPickerVisible(true);
            }}
            onTouchStart={() => {
              setIsCountryPickerVisible(true);
            }}
            error={errors?.chosenCountry && showErrors}
          />

          <TextInput
            nativeID="postcode"
            style={{
              height: AppConfig.Styles.inputHeight,
              width: '49%',
            }}
            mode="outlined"
            label={t('postal_code')}
            placeholder="V6B 1A8"
            value={
              localVerification?.address?.postcode ??
              verification?.address?.postcode
            }
            onChange={localVerificaionSetter}
            error={errors['postal code'] && showErrors}
          />
        </View>
        <View
          style={[
            AppConfig.Styles.rowContainer,
            {
              justifyContent: 'flex-start',
              display: `${
                !errors['postal code'] && !errors?.country ? 'none' : ''
              }`,
            },
          ]}>
          <View style={[AppConfig.Styles.container]}>
            <HelperText type="error">
              {simpleValidator.current.message(
                'chosenCountry',
                localVerification?.address?.country,
                'required',
              )}
            </HelperText>
          </View>
          <View style={[AppConfig.Styles.container]}>
            <HelperText type="error">
              {simpleValidator.current.message(
                'postal code',
                localVerification?.address?.postcode,
                'required',
              )}
            </HelperText>
          </View>
        </View>
        <TextInput
          nativeID="email"
          style={{
            height: AppConfig.Styles.inputHeight,
          }}
          mode="outlined"
          label={t('web_login_email')}
          placeholder={t('email_description')}
          value={localVerification?.email ?? verification?.email}
          onChange={localVerificaionSetter}
          error={errors?.email && showErrors}
        />
        <HelperText type="error">
          {simpleValidator.current.message(
            'email',
            localVerification?.email,
            'required|email',
          )}
        </HelperText>
        <View style={{ flexDirection: 'row', width: '100%' }}>
          <InternationalPhoneInput
            id="phone number"
            value={
              localVerification?.phone
                ? `+${localVerification.phone.replace(/^\+/, '')}`
                : ''
            }
            defaultCountry={phoneCountry}
            onChange={phoneNumberUpdate}
            error={Boolean(showErrors && errors['phone number'])}
            label={t('phone_number')}
          />
        </View>
        <HelperText type="error">
          {simpleValidator.current.message(
            'phone number',
            localVerification?.phone,
            'required|validPhoneNumber',
          )}
        </HelperText>
        <View
          style={[
            AppConfig.Styles.rowContainer,
            { justifyContent: 'space-between', marginBottom: '8px' },
          ]}>
          <TextInput
            nativeID="dateOfBirth"
            style={{
              height: AppConfig.Styles.inputHeight,
              width: '100%',
            }}
            mode="outlined"
            label={t('date_of_birth')}
            placeholder={t('date_of_birth')}
            value={chosenDate ? format(chosenDate, 'yyyy-MM-dd') : ''}
            onFocus={() => {
              setOpenDateModal(true);
            }}
            error={errors['date of birth'] && showErrors}
          />
        </View>
        <HelperText type="error">
          {simpleValidator.current.message(
            'date of birth',
            localVerification?.dateOfBirth,
            'required|dateValidator',
          )}
        </HelperText>
        <View
          style={[
            AppConfig.Styles.rowContainer,
            {
              justifyContent: 'space-between',
              borderTopColor: '#dddddd',
              borderTopWidth: 1,
              paddingTop: 20,
              marginTop: 20,
            },
          ]}>
          <Button
            contentStyle={{
              width: 120,
              height: AppConfig.Styles.buttonHeight,
            }}
            labelStyle={{ color: 'black' }}
            onPress={onPressBack}>
            {t('back')}
          </Button>
          <Button
            contentStyle={{
              width: 120,
              height: AppConfig.Styles.buttonHeight,
            }}
            labelStyle={{ color: 'white' }}
            mode="contained"
            onPress={onPressNext}>
            {t('next')}
          </Button>
        </View>
      </View>
    </View>
  );
};

// @@ Default Component
export const Details = () => {
  const { theme } = useAppStore();
  const { t } = useLocalization();
  return (
    <View style={[AppConfig.Styles.container, AppConfig.Styles.center]}>
      <View style={[AppConfig.Styles.container, LoginStyles.container]}>
        <View style={[LoginStyles.contentContainer]}>
          {theme && (
            <HeaderView
              theme={theme}
              logo={
                <Svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 50 50"
                  fill={theme.primaryColor}
                  style={{ margin: 0, padding: 0 }}>
                  <VERIFICATIONFingerprint />
                </Svg>
              }
            />
          )}
          <ContentView
            title={t('personal_details')}
            description={t('personal_details_description')}
          />
        </View>
        <ActionView />
      </View>
    </View>
  );
};

export default Details;
